(function(){
    document.querySelectorAll('[data-toggle="scroll-to"]').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.preventDefault();

            var target = event.target.getAttribute('href');
            var top= document.querySelector(target).offsetTop;

            document.documentElement.scrollTo({
                top: top - 32,
                behavior: "smooth"
            });
        });
    });
})()